module.exports = __webpack_public_path__ + "img/erin-patterson4.88e138f5.png";